import { ElementType, forwardRef } from 'react';
import { css } from '@emotion/react';
import { motion, AnimatePresence, MotionProps } from 'motion/react';
import { FlyoutMenuProps } from './types';

export type AnimatedMenuProps = Omit<FlyoutMenuProps, 'actions' | 'onClose'> &
  MotionProps & {
    as?: keyof JSX.IntrinsicElements;
  };

export const AnimatedMenu = forwardRef<HTMLElement, AnimatedMenuProps>(({ children, as = 'ul', ...rest }, ref) => {
  const Component = motion[as] as ElementType;
  return (
    <AnimatePresence>
      <Component
        css={css`
          background: white;
          list-style-type: none;
          margin: 0;
          padding: 0;
          position: absolute;
        `}
        ref={ref}
        {...rest}
      >
        {children}
      </Component>
    </AnimatePresence>
  );
});

AnimatedMenu.displayName = 'AnimatedMenu';
